import type { PropsWithChildren } from 'react';
import { cn } from '../../utils/cn';
import { cva, type VariantProps } from 'class-variance-authority';

const variants = cva( '', {
  variants: {
    variant: {
      default: '',
      bold: 'text-[#E2E8FF] font-medium'
    }
  }
} )

type InvoiceSummaryItemProps = PropsWithChildren<{
  className?: string;
}> & VariantProps<typeof variants>;

export const InvoiceSummaryItem = ( { children, className, variant = 'default' }: InvoiceSummaryItemProps ) => {

  return (
    <div className={ cn( 'contents', variants( { variant } ), className ) }>
      { children }
    </div>
  )
}

InvoiceSummaryItem.displayName = 'InvoiceSummaryItem';
